var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellO(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.77 12.11v.003c-.05.282-.173.967-1 .877-.56-.05-.82-.44-.76-1.16-.03-.9.36-1.77 1.18-2.6A3.9 3.9 0 0114.05 8c.63 0 .95.3.95.88 0 .6-.32.89-.95.9-.6 0-1.1.25-1.55.72-.616.653-.683 1.219-.722 1.543l-.008.067z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 2v1.05C8.505 3.498 5 6.933 5 12v7.65c0 .36-.08 2.35-.53 2.35H4c-.67 0-1 .33-1 1 0 .67.33 1 1 1h6.515c-.01.095-.015.195-.015.3 0 1.77 1.68 3.3 3.5 3.3s3.5-1.53 3.5-3.3c0-.105-.006-.205-.019-.3H24c.67 0 1-.33 1-1 0-.67-.33-1-1-1h-.45c-.45 0-.55-1.99-.55-2.35V12c0-5.074-3.497-8.512-8-8.952V2c0-.67-.33-1-1-1-.67 0-1 .33-1 1zm8.5 20c-.44 0-.5-1.54-.5-2v-8c0-4.07-3.17-7-7-7a6.9 6.9 0 00-7 7v8c0 .03-.06 2-.5 2h15zm-5.755 2h-3.49c.061.894.64 1.59 1.745 1.59v.01c1.104 0 1.683-.713 1.745-1.6z",
    clipRule: "evenodd"
  })));
}

export default SvgBellO;